import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-browse-card',
  templateUrl: './browse-card.component.html',
  styleUrls: ['./browse-card.component.css']
})
export class BrowseCardComponent implements OnInit {

  @Input() public title;
  @Input() public relevantWells;
  @Input() public availableRecords;
  @Input() public color;

  @Output() export = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
  }

  exportClicked() {
    this.export.emit(this.title);
  }

}
